// GET
export const GET_SUBSCRIBER_DETAILS = '/subscriber/details';
export const GET_SUBSCRIBER_PRODUCTS_UUIDS = '/subscriber/products/uuids';
export const GET_SUBSCRIBER_IN_LOCAL = '/subscriber/inLocal';
export const GET_SUBSCRIBER_ACTIVE_DEVICES =
	'/subscriber/devices/active?order[0][column]=9&order[0][dir]=desc';

// POST
export const POST_SUBSCRIBER_LOGIN_API = '/subscriber/login';
export const POST_SUBSCRIBER_LOGIN_EXTERNAL_API = '/subscriber/login/external';
export const POST_SUBSCRIBER_LOGOUT = '/subscriber/logout';
export const POST_SUBSCRIBER_DEVICE_NAME = '/subscriber/device/name';
export const POST_SUBSCRIBER_AGREEMENTS_ACCEPT =
	'/subscriber/agreements/accept';
export const POST_MULTIPLE_ACCOUNT_LOGIN_API =
	'/subscriber/login/multipleAccount';

// PUT
export const PUT_SUBSCRIBER_DEVICE_TOGGLE = '/subscriber/device/toggle';
export const PUT_SUBSCRIBER_HIDE_UNAVAILABLE = '/subscriber/hide/unavailable';
